import React from 'react'

import ICONS from './icons'

export type IconName = keyof typeof ICONS

export type IconProps = React.SVGProps<SVGSVGElement> & {
  name: IconName
  color?: string
  size?: number
  className?: string
  /** @deprecated prefer className */
  style?: React.CSSProperties
  /** @deprecated prefer className */
  opacity?: number
}

const Icon = ({ name, color, size, opacity, style, ...props }: IconProps) => {
  const SvgIcon = ICONS[name]

  if (!SvgIcon) {
    if (process.env.NODE_ENV === 'development') {
      throw new Error(`Icon "${name}" not found`)
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Icon "${name}" not found`)
      return null
    }
  }

  return (
    <SvgIcon
      aria-label={name}
      data-testid={name}
      fill={color || 'currentColor'}
      width={size}
      height={size}
      style={{ opacity, ...style }}
      {...props}
    />
  )
}

export default Icon
